package com.cybersoftsolution.cybersoftsolutionweb.components.dropDowns

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.role
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.GeneralKind
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.palette.SilkWidgetColorGroups
import org.jetbrains.compose.web.attributes.href
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

@Composable
    fun ButtonDropdown(
        modifier: Modifier = Modifier,
        style: CssStyle<GeneralKind>,
        id: String,
        placeholder : String = "",
        items: List<String> = emptyList(),
        selectedItem: String? = null,
        onItemSelected: (String) -> Unit = {}
    ){





        Div (
            attrs = Modifier
                .id(id)
                .then(modifier)
                .classNames("dropdown")
                .toAttrs()

        ) {
            A(
                attrs = Modifier
                    .classNames("btn","btn-primary","dropdown-toggle")
                    .role("button")
                    .toAttrs{
                        href("#")
                        attr("data-bs-toggle", "dropdown")
                        attr("aria-expanded", "false")
                    }
            ){
                Text(selectedItem ?: placeholder)
            }


            Ul(
                attrs = Modifier
//                    .fillMaxWidth()
                    .classNames("dropdown-menu")
                    .toAttrs()

            ) {

                items.forEach { item ->
                    Li {
                        A(
                            attrs = Modifier
                                .classNames("dropdown-item")
//                                .color(Colors.Black)
//                                .fontSize(14.px)
//                                .cursor(Cursor.Pointer)
                                .onClick { onItemSelected(item) }
                                .toAttrs()
                        ) {
                            Text(value = item)
                        }
                    }
                }


            }




        }


    }